module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcElEQVQ4T2M8k2b8n4ECwDhMDRB3j2eQ9Exk+P3lAzx0Xu1ZyvD6wGqM0MIaBiAD2IQkGB4v7yQYvLQzgF/biuHdqe1gF/z/85vh7YmtWF2D0wUCBg4MHy4cgBvwau8y0gwY+DCgyAUE4w5JwTDICwD6AFBRVfQIWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicons/favicon-16x16.png
// module id = BWnZ
// module chunks = 1